import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import {
  Input,
  Button,
  InputGroup,
  InputLeftElement,
  Box,
  Spinner,
} from "@chakra-ui/react";

import signin_stock_rb_1_logo from "assets/images/logos/signin_page/signin_stock_rb_1_logo.png";
import signin_stock_rb_2_logo from "assets/images/logos/signin_page/signin_stock_rb_2_logo.png";

import signin_email_logo from "assets/images/icons/signin_email_logo.svg";

import forms_ui_element from "assets/images/ui_elements/forms_ui_element.png";

import { GetForgetPasswordService } from "services/ForgetPasswordService";

import useDocumentTitle from "hooks/useDocumentTitle";
import { isValidEmail } from "utils/ValidationUtils";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";

export default function ForgerPasswordView() {
  useDocumentTitle("Reset Password");

  const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [signInError, setSignInError] = useState("");
  const [showContactSupport, setShowContactSupport] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateInput = (email) => {
    let flag = true;

    if (email === "") {
      setSignInError("Please enter your email address");
      return false;
    }

    if (!isValidEmail(email)) {
      setSignInError("Please enter a valid email address");
      return false;
    }

    return flag;
  };

  const handleSubmit = async (e) => {
    setSignInError("");
    setShowContactSupport(false);

    e.preventDefault();

    if (!validateInput(email)) {
      return;
    }

    try {
      setLoading(true);
      const res = await GetForgetPasswordService({ user_email: email });

      if (res.status === 200) {
        setSignInError("Password reset link sent to your email");
        setSuccess(true);
      } else {
        setSignInError("Invalid email address");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);

      if (error.response) {
        if (error.response.status === 400) {
          const error_resp = error?.response?.data?.message;

          setShowContactSupport(true);

          if (error_resp.includes("not active")) {
            setSignInError("Account is inactive.");
            return;
          }

          if (error_resp.includes("not onboarded")) {
            setSignInError(
              "Your email has not been verified. Please check your email for the verification link. "
            );
            return;
          }

          setSignInError(error.response.data.message);
        } else if (error.response.status === 404) {
          setSignInError("Email not found");
          setShowContactSupport(true);
        } else {
          setSignInError(
            "Something went wrong. Contact support for assistance"
          );
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateToLogin = () => {
    // navigate to login page

    navigator("/login");
  };

  return (
    <>
      <div className="sign-in-main-container">
        <div className="signin-left-panel-ts     ">
          <div className=" h-full flex flex-row justify-center  ">
            <div className="flex flex-col justify-center   ">
              <div className=" flex flex-col gap-8    ">
                <img
                  src={signin_stock_rb_1_logo}
                  className=" mx-auto w-16 h-16  "
                  alt="logo"
                />
                <img
                  src={signin_stock_rb_2_logo}
                  className=" mx-auto w-[11.7rem] h-[3.7rem] "
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="signin-right-layout-panel z-20   ">
          <div className="    signin-right-container-tc ">
            {success && (
              <div className="">
                <div className="mb-12 flex flex-col gap-5 ">
                  <div className="flex flex-row justify-center">
                    <h1 className="pt-2 pl-2 ">
                      Please check your email for further instructions on
                      reseting your password!
                    </h1>
                  </div>
                  <div className="flex flex-row justify-center">
                    <Button variant={"link"} onClick={handleNavigateToLogin}>
                      Click here to go back to login page
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {!success && (
              <div className="  lg:pr-52  ">
                <div className="mb-12">
                  <h1 className="pt-2 pl-2 ">Reset Password</h1>
                </div>

                <form onSubmit={handleSubmit}>
                  {/* {signInError && (
                    <div className="ml-2.5">
                      <p className="text-red-500 font-bold"> {signInError} </p>
                    </div>
                  )} */}

                  <div className="pb-7   w-[100%] sm:w-[25rem] xl:w-[28rem] ">
                    <p className="label">Email Address</p>
                    <InputGroup size="lg">
                      <InputLeftElement
                        sx={{ paddingTop: "15px" }}
                        pointerEvents="none"
                      >
                        <img src={signin_email_logo} />
                      </InputLeftElement>
                      <Input
                        name="user_email"
                        type="text"
                        placeholder="abc@email.com"
                        // width={"25rem"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        isInvalid={signInError}
                      />
                    </InputGroup>
                    {signInError && (
                      <FormErrorMessage
                        errorMsg={signInError}
                        showContactSupport={showContactSupport}
                      />
                    )}

                    <Box className="pt-[10px]  ">
                      <Button
                        variant="link"
                        sx={{
                          paddingX: "10px",
                          paddingY: "16px",
                        }}
                        onClick={handleNavigateToLogin}
                      >
                        Don't need to reset password? click here to sign in
                      </Button>
                    </Box>
                  </div>

                  <div className="mt-8 pl-2  w-[100%] sm:w-[25rem] xl:w-[28rem] ">
                    <Button
                      type="submit"
                      sx={
                        {
                          // width: "24rem",
                        }
                      }
                      isDisabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            sx={{ ml: "0.5rem" }}
                            size="lg"
                            color="white"
                          />
                        </>
                      ) : (
                        "Reset Password"
                      )}
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      <img
        src={forms_ui_element}
        className="absolute bottom-0 right-0  h-[30vh]  z-0    "
        alt="forms_ui_element"
      />
    </>
  );
}
